<div class="my-events-container">
    <ng-template #gotoLink>
        <app-action-link [href]="calendarUrl" [target]="'blank'">
            <span i18n="go to calendar text@@go-to-calendar">Go to the calendar</span><i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
        </app-action-link>
    </ng-template>

    <div class="d-none d-md-block float-md-right mt-1"><ng-container *ngTemplateOutlet="gotoLink"></ng-container></div>
    <h2 class="widget-header h4" i18n="organization upcoming events header@@organization-upcoming-events-header">Upcoming events</h2>
    <h3 class="text-muted h6" i18n="organization events sub header@@organization-events-sub-header" *ngIf="!calendarPageInfoUrl">Here you'll find common events that you can sign up to.</h3>
    <h3 class="text-muted h6" *ngIf="calendarPageInfoUrl">
      <span i18n="organization events sub header if url first part@@organization-events-sub-header-if-url-first-part">Use </span>
      <a href="{{calendarPageInfoUrl}}">this link</a>
      <span i18n="organization events sub header if url second part@@organization-events-sub-header-if-url-second-part"> to find out more about which events are included in the calendar.</span>
    </h3>
    <div class="d-block d-md-none mt-2 mt-md-0"><ng-container *ngTemplateOutlet="gotoLink"></ng-container></div>

    <div class="my-events my-events-mobile" *ngIf="allEvents; else loading">
        <!--New design starts from here-->
        <div class="row" *ngIf="allEvents?.length > 0; else noEvents">
            <div class="col-12 col-md-6 col-lg-4 col-xl-4 col-xxl-2 pt-4" *ngFor="let event of eventsToDisplay">
                <div [appCssBackgroundImageProxy]="event.BannerUrl" class="event-image">
                    <div class="box" [ngClass]="setCalendarStyle(event)">
                        <div class="box-btm">
                            <div [ngClass]="setLayOverStyle(event)">
                                <div class="pl-4 pr-4 pt-3">
                                    <a class="events-clickable-link" title="{{event.Title}}" href="{{event.ItemUrl}}">
                                        <h3 class="h55 mb-0 extra-bold">
                                            <span class="badge accent-2-bg-color text-uppercase rounded-0 mr-1" *ngIf="event.ShowNewOrModifiedBadge" i18n="app tile box new@@app-tile-box-new">New</span>
                                            {{(event.Title.length>30)? (event.Title | slice:0:30)+'...':(event.Title)}}
                                        </h3>
                                    </a>
                                </div>
                                <div class="small element pt-3 pb-1 pl-4 metadata-text">
                                    <span *ngIf="event.Location">
                                        <i i18n-aria-label="@@event-location" aria-label="Event location" title="{{event.Location}}" role="img" alt="Event location" class="fa fa-map-marker mr-1"></i>{{(event.Location.length>30)? (event.Location | slice:0:30)+'...':(event.Location)}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="box-footer" [ngClass]="setCalendarStyle(event)">
                        <div class="box-btm-footer text-center">
                            <div [ngClass]="setLayOverStyle(event)">
                                <div class="pt-3 pb-3">
                                    <span class="bolder">
                                        <span *ngIf="event.EventInstance === 'on diff day' && !event.AllDayEvent">{{event.EventDate| date:'d LLL'}} {{event.EventDate| date:'H:mm'}} - {{event.EndDate| date:'d LLL'}} {{event.EndDate| date:'H:mm'}}</span>
                                        <span *ngIf="event.EventInstance === 'on same day' && !event.AllDayEvent">{{event.EventDate| date:'d LLL'}} {{event.EventDate| date:'H:mm'}} - {{event.EndDate | date:'H:mm'}}</span>
                                        <span *ngIf="event.EventInstance === 'on diff day' && event.AllDayEvent">{{event.EventDate| date:'d LLL'}} - {{event.EndDate| date:'d LLL'}}<span class="pl-1" i18n="event allday@@event-allday">(All day)</span></span>
                                        <span *ngIf="event.EventInstance === 'on same day' && event.AllDayEvent">{{event.EventDate| date:'d LLL'}}<span class="pl-1" i18n="event allday1@@event-allday1">(All day)</span></span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--New design ends here-->

        <div class="row justify-content-center mt-4" *ngIf="numEventsShowing < maxEventsToShow && allEvents.length > numEventsShowing else linkToCalendar">
            <div class="col-auto">
                <button mat-flat-button color="accent" class="events-show-more-btn" (click)="clickShowMore()">
                    <span i18n="events show more@@events-show-more">Show more events</span><i class="ml-2 ms-Icon ms-Icon--ChevronDown" aria-hidden="true"></i>
                </button>
            </div>
        </div>
        <div class="row justify-content-center mt-4" *ngIf="numberOfShowMoreClicks === maxNumberOfShowMore">
            <div class="col-auto">
                <button mat-flat-button color="accent" class="events-show-more-btn" (click)="clickShowLess()">
                    <span i18n="events show more@@events-show-less">Show less events</span><i class="ml-2 ms-Icon ms-Icon--ChevronUp" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <ng-template #linkToCalendar>
            <div class="col-auto mt-4 text-center">
                <span i18n="events find more@@events-find-more">Find more events in the <app-action-link [href]="calendarUrl" [target]="'blank'">Calendar</app-action-link></span>
            </div>
        </ng-template>

    </div>

</div>
<ng-template #noEvents>
    <div *ngIf="errorSubject$ | async as err; else noRealEvents">
        <app-error-templates [error]="err.status" [componentName]="componentName"></app-error-templates>
    </div>
    <ng-template #noRealEvents>
        <div>
            <app-text-placeholder>
                <p class="text-muted" i18n="no events@@no-events">No future events.</p>
            </app-text-placeholder>
        </div>
    </ng-template>
</ng-template>

<ng-template #loading>
    <div>
        <app-widget-placeholder></app-widget-placeholder>
    </div>
</ng-template>

